module.exports = __webpack_public_path__ + "img/frame (248).9f751cf4.jpg";